export default {
  title: '兌換記錄',
  giftInfo: '禮品信息',
  giftInfoPlaceholder: '請輸入關鍵詞搜索',
  memberInfo: '會員信息',
  memberInfoPlaceholder: '請輸入關鍵詞搜索',
  shipStatus: '發貨狀態',
  exchangeTime: '兌換時間',
  startDate: '開始時間',
  endDate: '結束時間',
  country: '國家',
  exchangePrice: '兌換價格',
  exchangeQty: '兌換數量',
  contactPhone: '聯繫電話',
  shippingAddress: '收貨地址',
  spec: '規格',
  specName: '規格',
  singleSpec: '單規格',
  statusPending: '待處理',
  statusShipped: '已發貨',
  statusAll: '全部',
  statusRedeemed: '已兌換',
  statusCompleted: '已完成',
  statusCancelled: '已取消',
  statusFailed: '失敗',
  ship: '發貨',
  detail: '詳情',
  shipModalTitle: '發貨',
  shipDetailTitle: '發貨信息',
  expressCompany: '快遞公司',
  expressCompanyPlaceholder: '請輸入快遞公司名稱',
  trackingNo: '物流單號',
  trackingNoPlaceholder: '請輸入物流單號',
  remark: '備註',
  remarkPlaceholder: '請輸入備註',
  expressCompanyRequired: '請輸入快遞公司',
  trackingNoRequired: '請輸入物流單號',
  timeRequired: '請選擇兌換時間',
};
